import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, FormGroup, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";
import AuthService from "../services/authService";
import UserContext from '../contexts/UserContext';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
    };

    const onChangePassword = (e) => { 
        const password = e.target.value;
        setPassword(password);
    };

    const handleLogin = (e) => {
        e.preventDefault();

        setMessage("");
        setLoading(true); 

        try {
            AuthService.login(username, password).then(
                (userData) => {
                    setUser({ username: userData.username, organization: userData.organization, isOwner: userData.isOwner });
                    navigate('/main');
                },
                (error) => {
                    setMessage('Unknown username or password');
                }
            )
        } catch (error) {
            const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            setMessage(resMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Row className="justify-content-center mt-5">
                <Col md={6}>
                    <h2 className="text-center mb-4">Login</h2>
                    <Form onSubmit={handleLogin}>
                        <FormGroup>
                            <Label for="username">Username</Label>
                            <Input
                                type="username"
                                name="username"
                                value={username}
                                onChange={onChangeUsername}
                                id="username"
                                placeholder="Enter your username"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Password</Label>
                            <Input
                                type="password"
                                name="password"
                                value={password}
                                onChange={onChangePassword}
                                id="password"
                                placeholder="Enter your password"
                                required
                            />
                        </FormGroup>
                        <Button color="primary" block disabled={loading}>
                        {loading && (
                            <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span>Login</span>
                        </Button>
                        <Row className="mt-3">
                            <Col className="text-center">
                                <p>Don't have an account? <Link to="/register">Register here</Link></p>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col className="text-center">
                                <Link to="/forgot-password">Forgot Password?</Link>
                            </Col>
                        </Row>

                        {message && (
                            <div className="form-group">
                                <div className="alert alert-danger" role="alert">
                                    {message}
                                </div>
                            </div>
                        )}
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;